var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"chapterhead-banner"},[_c('img',{staticClass:"chapterhead-banner__image",attrs:{"src":_vm.imgSrc}}),_vm._v(" "),_c('h1',{staticClass:"chapterhead-banner__title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }